import { useOrders } from "@/lib/OrdersContext";
import { PageHeader, DataTable } from "@/components/PageHeader";
import { eur, shortId } from "@/lib/workshop";

const Stat = ({ id, label, value, gold }) => (
  <div data-testid={`billing-${id}`} className={`rounded-xl border p-5 ${gold ? "border-[var(--gold)]/30 bg-[#16120a]" : "border-white/5 bg-[#111114]"}`}>
    <p className="text-xs uppercase tracking-wider text-zinc-500">{label}</p>
    <p className={`font-display mt-2 text-2xl font-bold ${gold ? "text-[var(--gold)]" : ""}`}>{value}</p>
  </div>
);

const HEAD = ["Orden", "Cliente", "Matrícula", "Trabajo", "Importe", "Pago"];

export default function FacturacionPage() {
  const { searchAll: filtered, togglePago } = useOrders();
  const sum = (arr) => arr.reduce((s, o) => s + o.importe, 0);
  const paid = filtered.filter((o) => o.pagado);
  const pending = filtered.filter((o) => !o.pagado);

  const rows = filtered.map((o) => (
    <tr key={o.id} data-testid={`billing-row-${o.id}`} className="border-b border-white/5 transition-colors hover:bg-white/[0.02]">
      <td className="px-5 py-3 text-zinc-500">#{shortId(o.id)}</td>
      <td className="px-5 py-3 font-semibold">{o.cliente || "—"}</td>
      <td className="px-5 py-3 font-mono-plate text-xs">{o.matricula}</td>
      <td className="max-w-[260px] truncate px-5 py-3 text-zinc-400">{o.servicio}</td>
      <td className="px-5 py-3 font-semibold">{eur(o.importe)}</td>
      <td className="px-5 py-3">
        <button data-testid={`billing-payment-toggle-${o.id}`} onClick={() => togglePago(o.id)}
          className={`rounded-full px-2.5 py-1 text-[11px] font-semibold ${o.pagado ? "bg-emerald-500/15 text-emerald-400" : "bg-[var(--gold-soft)] text-[var(--gold)]"}`}>
          {o.pagado ? "Pagado" : "Pendiente"}
        </button>
      </td>
    </tr>
  ));
  return (
    <>
      <PageHeader title="Facturación" subtitle="Importes de todas las órdenes y su estado de cobro" />
      <div className="mb-6 grid gap-3 sm:grid-cols-3">
        <Stat id="total" label="Facturación estimada" value={eur(sum(filtered))} gold />
        <Stat id="paid" label="Cobrado" value={eur(sum(paid))} />
        <Stat id="pending" label="Pendiente de cobro" value={eur(sum(pending))} />
      </div>
      <DataTable testid="billing-table" head={HEAD} rows={rows} empty="Aún no hay órdenes" />
    </>
  );
}
